GameResLoad = xClass("GameResLoad")
const GlobalEvent = require("hecore/EventDispatcher").Event

let GameResLoadTask = xClass("GameResLoadTask")
GameResLoadTask.prototype.ctor = function (levelId, finishCallback, onFail, preload = false) {
    this.levelId = levelId
    this.finishCallback = finishCallback
    this.onFail = onFail
    this.state = 0
    this.preload = preload //预加载
    this.needReload = false //需要重新加载（防止资源被卸载导致进入关卡失败）
    this.needRunAfterComplete = !preload //完成后需要运行
}
GameResLoadTask.prototype.start = function () {
    this.needReload = false
    DynamicGuideLogic.getInstance().loadNeed().then(dataMap => {
        cc.log("[DynamicGuide]", "load success dataMap.", dataMap);
        DynamicGuideLogic.getInstance().initUseConfig()//
        this.loadLevelConfig()
    }).catch(err => {
        this.loadConfigFail()
        cc.error("[DynamicGuide]", "load loadNeed fail.", err);
        require("clover/sns/SnsProxy").getInstance().showDialog({
            text: "配置加载失败，请重试",
            needOkBtn: true,
            okBtnText: "重试",
        }, () => {
            this.start()
        })
    })
}
GameResLoadTask.prototype.loadLevelConfig = function () {
    let self = this
    let loadLevelId = this.levelId
    let onFail = this.onFail
    let isMysteryIsland = false
    let lvResPath = LevelConfigManager.getInstance().getLevelConfigPath(loadLevelId, isMysteryIsland)
    let resList = [lvResPath];
    ["meta/game_map_res.json", "meta/game_guide_res.json"].forEach(v => {
        if (!cc.loader.getRes(v))
            resList.push(v);
    })
    cc.loader.load(resList, function (error) {
        if (error) {
            // if (onFail && type(onFail) === "function") {
            //     onFail()
            // } else {
            //     Toast.make(curryQuickGetErrorText(0))
            // }
            self.loadConfigFail()
            return
        }
        let MapResConfig = require("clover/config/level/MapResConfig")
        MapResConfig.load();

        var levelConfig = LevelConfigManager.getInstance().getLevelConfigByID(loadLevelId, null, self.otherData);
        unloadResList(lvResPath);
        if (levelConfig) {
            // if (actualLevelId) {
            //     LevelConfigManager.getInstance().replaceLevelID(actualLevelId, self.levelId)
            // }
            if (self.levelType === GameLevelType.kPvp && self.otherData && self.otherData.randomSeed) {
                levelConfig.randomSeed = self.otherData.randomSeed
            }
            var fileList = levelConfig.getDependingSpecialAssetsList(null, self.otherData)[0]
            var prefillAnis = levelConfig.getDependingSpecialAssetsList(null, self.otherData)[1]
            if (self.otherData && self.otherData.contestUid) {
                // cc.log("------------- challenge res -------------------")
                fileList = fileList.concat(["packed/ChallengeActivityRes.pack"])
            }

            if (self.levelType == GameLevelType.kPvp) {
                // 友谊赛
                fileList = fileList.concat([
                    "cocos/level.plist"
                ])
            }
            // 如果是神秘岛关卡增加 动画资源
            if (self.levelType == GameLevelType.kMysteryIsland) {
                _G.RunningGameLevelType = GameLevelType.kMysteryIsland
                fileList = fileList.concat([
                    "packed/MysteryIsland.pack",
                    "packed/BaseBowknotAssets.pack", //其中一种动画用到了蝴蝶资源需要加载
                    "cocos/boss_common_res.plist"
                ])
            } else {
                // 这个变量目前只有神秘岛在用这里 保证和原来一致
                _G.RunningGameLevelType = null
            }
            // 判断是否播放紫咪动画 播放加入紫咪动画资源
            // if (self.actPreProp && self.actPreProp.purpleAmyMagic && self.actPreProp.purpleAmyMagic.props &&
            //     $len(self.actPreProp.purpleAmyMagic.props) > 0) {
            //     fileList = fileList.concat([
            //         "packed/PurpleAmyMagicPropAnim.pack"
            //     ])
            // }
            //  紫咪动画不做判断 直接加载
            fileList = fileList.concat([
                "packed/PurpleAmyMagicPropAnim.pack"
            ])

            // 判断是否在晋级赛
            // fileList = fileList.concat([
            //     "packed/QualifyGame.pack"
            // ])
            // fileList = fileList.concat([
            //     "packed/PurpleAmyMagicMain.pack"
            // ])
            fileList = fileList.concat([
                "cocos/guide.plist",
                "cocos/guide_guide_node.csb",
            ])

   
            fileList = fileList.concat([
                "packed/NuclearItemAssets.pack",
                "packed/NuclearGameUI.pack",
            ])
            var musics = levelConfig.getNeedMusics()
            var resource = table([1, "kPlist", fileList], [1, "kMusics", musics], [1, "kPrefillPool", prefillAnis])

            self.fileList = fileList
            self.resourceList = resource
            self.loadRes()
            // resource
            // scene.run()
        } else {
            Toast.make(tostring(self.levelId) + "关卡不存在！！！")
        }
    })

}
GameResLoadTask.prototype.loadRes = function () {
    let self = this
    // var resourceList = self.resourceList
    let resourceList = self.resourceList
    if (!resourceList) {
        self.loadComplete()
        return
    }
    var loader = FrameLoader.new()
    var plistLen = $len(resourceList.kPlist)
    for (var i = 1, v = resourceList.kPlist[1]; i <= plistLen; i++, v = resourceList.kPlist[i]) {
        if (v != null) {
            loader.add(v)
        }
    }
    for (var i = 1, v = resourceList.kMusics[1]; v; i++, v = resourceList.kMusics[i]) {
        //TODO:test only
        loader.add(v, kFrameLoaderType.sfx)
    }
    if (resourceList.kPrefillPool && resourceList.kPrefillPool[1]) {
        for (let i = 1, v = resourceList.kPrefillPool[1]; v; i++, v = resourceList.kPrefillPool[i]) {
            loader.add(v, kFrameLoaderType.csb)
        }
    }

    //loader.add("flash/test_big.png")
    loader.add(GameResLoad.getInstance().getScript)
    console.log("start level load");

    function onFrameLoadComplete() {
        loader.removeAllEventListeners()
        if (self.finishCallback) {
            // step.120 新用户第一关加载完毕
            if (_G.kIsNewUser && !_G.firstLevelLoadComplete) {
                _G.firstLevelLoadComplete = true;
                dc4UserLoad(115);
            }
            DCAssist.dc4LevelUserOp120(self.levelId)
        }
        self.loadComplete()
        // b组卸载掉粒子动画
        if (UserManager.getInstance().getGroupByKey("snow_abtest") == "b"){
            ResManager.release(["cocos/varsnow_flake.plist"])
        }
    }

    function onFrameLoadProgress() {
        var progress = loader.loaded / loader.getLength()
        // cc.log("GameResLoad progress ", progress)
        // self.updateProgress(progress)
        if(self.needRunAfterComplete){//非预加载任务才需要同步进度消息
            GlobalEventDispatcher.getInstance().dispatchEvent(GlobalEvent.new(kGlobalEvents.kGameResLoadProgress, {
                progress: progress
            }))
        }
    }

    function onFrameLoadError(evt) {
        let err = ""
        let stack = ""
        if (!self.isRetry){
            err = "level_loading_scene onFrameLoadError:" + JSON.stringify(evt.data) + ",loadList:" + JSON.stringify(loader.list)
            stack = "level_loading_scene onFrameLoadError"
        }else{
            err = "level_loading_scene retry onFrameLoadError:" + JSON.stringify(evt.data) + ",loadList:" + JSON.stringify(loader.list)
            stack = "level_loading_scene retry onFrameLoadError"
        }
        if (window.logCenter) {
            window.logCenter.error(err, "LevelLoadingScene", 202, 31, {
                "stack": stack
            });
        } else {
            cc.error("onFrameLoadError:" + err,stack);
        }

        require("clover/sns/SnsProxy").getInstance().showDialog({
            text: "资源加载失败，请重试",
            needOkBtn: true,
            okBtnText: "重试",
        }, () => {
            self.isRetry = true
            loader.retry()
        })
    }
    loader.addEventListener(Events.kComplete, onFrameLoadComplete)
    loader.addEventListener(Events.kProgress, onFrameLoadProgress)
    loader.addEventListener(Events.kError, onFrameLoadError)
    loader.load()
}
GameResLoadTask.prototype.loadComplete = function () {
    let self = this
    if (self.finishCallback) {
        self.finishCallback(self.fileList)
    }
    GameResLoad.getInstance().loadComplete(self)
}
GameResLoadTask.prototype.loadConfigFail = function () {
    let self = this
    this.onFail && this.onFail()
    Toast.make(curryQuickGetErrorText(0))
    GameResLoad.getInstance().loadConfigFail(self)
}
let instance = null
GameResLoad.getInstance = function () {
    let self = this
    if (!instance) {
        instance = GameResLoad.create()
    }
    return instance
}
GameResLoad.prototype.ctor = function () {
    // this.a = {}
    this.taskList = {}
    this.pvpTask = null
}
const STATE_CODE = {
    LOADING: 0,
    COMPLETE: 1,
}
// 由于pvp内置资源加载逻辑导致无法进行资源复用 这里特殊处理
GameResLoad.prototype.startPvp = function (loadLevelId, finishCallback, onFail, extra) {
    let self = this
    let task = this.pvpTask
    if (!task){
        task = GameResLoadTask.create(loadLevelId, finishCallback, onFail)
        task.start()
        task.isPvP = true
        self.initExtra(task, extra)
        this.pvpTask = task
    }
    return true
}
GameResLoad.prototype.initExtra = function (task, extra) {
    if(extra && task){
        for (const key in extra) {
            task[key] = extra[key]
        }
    }
}
GameResLoad.prototype.start = function (loadLevelId, finishCallback, onFail,extra) {
    let self = this
    cc.log("GameResLoad start extra ",extra)
    let task = this.getTask(loadLevelId)
    let levelId = loadLevelId
    if (task) {
        self.initExtra(task, extra)
        task.finishCallback = finishCallback
        task.onFail = onFail
        task.needRunAfterComplete = true //任务被执行则需要完成后运行
        if (task.state == STATE_CODE.COMPLETE ) {//&& task.preload
            var runningScene = cc.Director.getInstance().getRunningScene()
            if (task.needReload || runningScene.name == "GameScene" || runningScene.name == "ReplayGameScene") { //
                //需要重新load（加载之后完成其他关卡的进出 或者当前在gamescene中均需要重新加载）
                cc.log("GameResLoad start need to reload", levelId)
                task.start()
            } else {
                cc.log("GameResLoad start no need to reload", levelId)
                task.loadComplete()
                return false
            }
            // finishCallback && finishCallback()
        } else {
            cc.log("GameResLoad start waiting for loading to complete", levelId)
        }
    } else {
        cc.log("GameResLoad start no current task", levelId)
        task = GameResLoadTask.create(loadLevelId, finishCallback, onFail)
        task.start()
        self.initExtra(task, extra)
        this.add(loadLevelId, task)
    }
    return true
}
GameResLoad.prototype.add = function (levelId, task) {
    this.taskList[levelId] = task
}
GameResLoad.prototype.del = function (levelId) {
    cc.log("GameResLoad del",levelId)
    this.taskList[levelId] = null
    delete this.taskList[levelId]
}
GameResLoad.prototype.getTask = function (levelId) {
    return this.taskList[levelId]
}

GameResLoad.prototype.getPreloadTask = function () {
    for (const key in this.taskList) {
        let task = this.taskList[key]
        if (task && task.preload) {
            return task
        }
    }
}
// 设置预加载任务需要重新加载
GameResLoad.prototype.setProloadTaskNeedReload = function () {
    cc.log("GameResLoad 更新为需要重新加载")
    let task = this.getPreloadTask()
    if (task) task.needReload = true
}

GameResLoad.prototype.checkPreload = function () {
    let preloadTask = this.getPreloadTask()
    let isMysteryIsland = MysteryIslandManager.getInstance().isOpen()
    if (!isMysteryIsland) return
    let getLoadLevelId = ()=>{
        let levelId = UserManager.getInstance().getUserRef().getTopLevelId()
        if (isMysteryIsland){
            let levelInfo = MysteryIslandManager.getInstance().getLevelInfo()
            levelId = levelInfo.mainLevelId
        }
     
        cc.log("GameResLoad checkPreload levelId ",levelId)
        return levelId

    }
    let loadLevelId = getLoadLevelId()
    let task = this.getTask(loadLevelId)
    if(preloadTask && loadLevelId == preloadTask.levelId){
        if (preloadTask.needReload){
            cc.log("GameResLoad checkPreload 重新预加载 ", preloadTask.levelId)
            preloadTask.start()
        }else{
            cc.log("GameResLoad checkPreload 当前已预加载 ", preloadTask.levelId)
        }
    }else{
        task = GameResLoadTask.create(loadLevelId, null, null, true)
        if (isMysteryIsland){
            task.levelType = GameLevelType.kMysteryIsland
        }
        task.start()
        this.add(loadLevelId, task)  
    }
    // if (!preloadTask && !task) {
    //     task = GameResLoadTask.create(loadLevelId, null, null, true)
    //     if (isMysteryIsland){
    //         task.levelType = GameLevelType.kMysteryIsland
    //     }
    //     task.start()
    //     this.add(loadLevelId, task)
    // } else {
    //     if (preloadTask.needReload){
    //         cc.log("GameResLoad checkPreload 重新预加载 ", preloadTask.levelId)
    //         preloadTask.start()
    //     }else{
    //         cc.log("GameResLoad checkPreload 当前已预加载 ", preloadTask.levelId)
    //     }
    // }
}




GameResLoad.prototype.getScript = function () {
    if (window.mini && mini.supportSubpackage()) {
        return new Promise((resolve, reject) => {
            mini.loadSubpackage({
                name: 'game',
                success: res => {
                    cc.log('load subpack success', res)
                    resolve(res)
                },
                fail: res => {
                    cc.warn('load subpack fail', res)
                    reject(res)
                }
            })
        })
    } else {
        return require.ensure([], () => {
            require.context('../gamePlay', true, /^((?!mode\/WeeklyMode).)*$/)
            require.context('../itemView')
            require.context('../levelTarget')
            require.context('../animation', false, /^Tile.+\.js$/)
            require.context('../animation/boss')
            require.context('../animation/background')
            require.context('../gameGuide/childAni')
        }, null, 'game')
    }

}
GameResLoad.prototype.loadComplete = function (task) {
    let self = this
    cc.log("GameResLoad checkPreload loadComplete ", task.levelId)
    if (task.isPvP){
        this.pvpTask = null
        return
    }
    task.state = STATE_CODE.COMPLETE
    if (task.needRunAfterComplete) {
        // self.del(task.levelId)
        self.enterGameBefore()
        GlobalEventDispatcher.getInstance().dispatchEvent(GlobalEvent.new(kGlobalEvents.kGameResLoadProgress, {
            progress: 1
        }))
    }
}
GameResLoad.prototype.loadConfigFail = function (task) {
    let self = this
    if (task.isPvP){
        this.pvpTask = null
        return
    }
    self.del(task.levelId)

}
GameResLoad.prototype.enterGameBefore = function () {
    if (window.mini) {
        SnsProxy.getInstance().tryShowHideCustomAdWhenPanelPop(false, true, true)
    }
    // 卸掉宝箱，岛屿
    var releaseRes = [];
    ["packed/HomeStarChestRes.pack"].forEach(e => {
        if(e){
            releaseRes.push(e);
        }
    });
    let IslandsManager = require("clover/scene/component/IslandsSystem/IslandsManager");
    let topIslandId = UserManager.getInstance().getCurrentIslandsIdByLevel();
    let topIslandConfig = UserManager.getInstance().getIslandConfigById(topIslandId);
    let islandRes = IslandsManager.getInstance().getIslandRes(topIslandConfig);
    islandRes.resList.forEach(e => {
        releaseRes.push(e);
    });
    UIUtils.releaseLoadedEffectRes()
    cc.log("GameResLoad enterGameBefore releaseRes", releaseRes);
    ResManager.release(releaseRes);
}

module.exports = GameResLoad